import LivestreamZoomPage from "../components/livestream/zoom-page";

export default <template><LivestreamZoomPage @topic={{@model}} /></template>
